import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  DateInput,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';
import { Grid } from '@mui/material';

const statusChoices = [
  { id: 'active', name: 'Active' },
  { id: 'expired', name: 'Expired' },
  { id: 'pending', name: 'Pending' },
  { id: 'revoked', name: 'Revoked' },
];

export const DriverCertificationCreate = () => (
  <Create>
    <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <ReferenceInput source="driverId" reference="drivers">
            <SelectInput optionText={(record: any) => record?.user?.name ? `${record.user.name} (Driver ID: ${record.id})` : `Driver ID: ${record?.id}`} validate={required()} fullWidth />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <ReferenceInput source="certificationTypeId" reference="certification-types">
            <SelectInput optionText="name" validate={required()} />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="otherName" label="Other/Custom Name" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput 
            source="status" 
            choices={statusChoices}
            defaultValue="active"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <DateInput source="completedDate" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <DateInput source="expiryDate" fullWidth />
        </Grid>
        <Grid item xs={12}>
          <TextInput source="description" multiline rows={3} fullWidth />
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
);